<template>
    <Autocomplete
        @input="handleInput"
        @selected="handleSelected"
        value-prop="description"
        :name="name"
        :placeholder="placeholder"
        :items="results"
    >
        <template slot="item" slot-scope="slot">
            <slot name="item" :data="slot.data"></slot>
        </template>
    </Autocomplete>
</template>

<script>
import Autocomplete from './Autocomplete';
import debounce from 'lodash.debounce';

var _data = {};

export default {
    components: {Autocomplete},
    props: {
        name: {
            type: String
        },
        placeholder: true,
        api: {
            type: Object
        },
        debounce: {
            type: Number,
            default: 800
        }
    },
    data () {
        return {
            activeValue: null,
            results: []
        };
    },
    computed: {
        google () {
            if (this.api) {
                return this.api;
            } else if (typeof window.google !== 'undefined') {
                return window.google;
            } else {
                throw new Error('No access to the Google Maps API.');
            }
        },
        requestDataDebounced () {
            return debounce(this.requestData, this.debounce);
        }
    },
    methods: {
        handleInput (query) {
            this.activeValue = query;
            this.requestDataDebounced(query);
        },
        handleSelected (data) {
            this.activeValue = data;
        },
        requestData (query) {
            var autocompleteService,
                request = {
                    input: query,
                    fields: ['id', 'name', 'formatted_address', 'geometry']
                };

            if (request.input.length) {
                if (typeof _data[request.input] === 'undefined') {
                    _data[request.input] = [];

                    autocompleteService = new this.google.maps.places.AutocompleteService();
                    autocompleteService.getQueryPredictions(request, (results, status, pagination) => {
                        var places = [];

                        if (results && results.length) {
                            results.forEach(function (result) {
                                if (result.place_id) {
                                    result.id = result.place_id;
                                    places.push(result);
                                }
                            });
                        }

                        _data[request.input] = places;
                        this.update(query);
                    });
                } else {
                    this.update(query);
                }
            }
        },
        update (query) {
            this.results = _data[query] || [];
        }
    }
};
</script>
